/* eslint-disable react/jsx-sort-props */
import React from 'react'

import { Box } from '@chakra-ui/react'

import { FacilityPointIProps } from '../../mapbox/types/types'
import { CENTER_CLUSTER_SIZE } from '../constants'
import { sortFacilitiesByStatus } from '../utils/sortFacilities'
import { BackgroundOverlay } from './BackgroundOverlay'
import { CenteredCluster } from './CenteredCluster'
import { CircularMenuItems } from './CircularMenuItems'
import { ConnectingLines } from './ConnectingLines'

interface CircularMenuIProps {
  isOpen: boolean
  onClose: () => void
  position: { x: number; y: number }
  facilities: FacilityPointIProps[]
  onFacilityClick: (facilityId: string) => void
}

export const CircularMenu: React.FC<CircularMenuIProps> = ({
  isOpen,
  onClose,
  position,
  facilities,
  onFacilityClick,
}) => {
  if (!isOpen || facilities.length === 0) return null

  const { ordered: orderedFacilities } = sortFacilitiesByStatus(facilities)

  const facilityCount = facilities.length
  const incidentCount = facilities.reduce(
    (sum, f) => sum + (f.incidentCount ?? 0),
    0
  )

  return (
    <Box
      height='100vh'
      left={0}
      pointerEvents='none'
      position='fixed'
      top={0}
      width='100vw'
    >
      <Box
        left={position.x - CENTER_CLUSTER_SIZE}
        pointerEvents='auto'
        position='absolute'
        top={position.y - CENTER_CLUSTER_SIZE}
        onClick={() => onClose()}
      >
        <BackgroundOverlay itemCount={orderedFacilities.length} />
        <CenteredCluster
          facilityCount={facilityCount}
          incidentCount={incidentCount}
        />
        <ConnectingLines orderedFacilities={orderedFacilities} />
        <CircularMenuItems
          clusterFacilityCount={facilityCount}
          onClose={onClose}
          onFacilityClick={onFacilityClick}
          orderedFacilities={orderedFacilities}
        />
      </Box>
    </Box>
  )
}
